import { LoginPage, useAuth } from '@skaleminds/jig-auth-sdk-ui';
import { Navigate, useSearchParams } from 'react-router-dom';
import { peekReturnTo } from '@/lib/return-to';

// Exact RD wording. sso_failed is handled by the SDK LoginPage's own banner.
export const LOGIN_ERROR_MESSAGES: Record<string, string> = {
  // not_invited: no longer produced by the server (sprint 8); kept so old /login?error=not_invited URLs still render.
  not_invited: "You haven't been invited to Clockit",
  deactivated: 'Your account has been deactivated',
  account_conflict: "Your account couldn't be matched to Clockit. Ask an Admin for help.",
};

export const RETURN_TO_MESSAGE =
  "Sign in to open the shared report. You can also open Clockit from the Skaleminds portal and you'll be taken to it.";

export function LoginRoute(): JSX.Element | null {
  const { user, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  if (isLoading) return null;
  if (user) return <Navigate to="/" replace />;

  const errorCode = searchParams.get('error');
  const message = errorCode ? LOGIN_ERROR_MESSAGES[errorCode] : undefined;
  // Sprint 5 (§6.6): a shared link is waiting for this sign-in.
  const returnPending = peekReturnTo() !== null;

  return (
    // tt-login scopes the token overrides in styles/login-theme.css to the SDK page.
    <div className="tt-login relative">
      {(message || returnPending) && (
        <div className="absolute inset-x-0 top-6 z-10 mx-auto w-full max-w-sm space-y-2">
          {message && (
            <div role="alert" className="rounded-lg border border-danger/40 bg-danger/10 px-4 py-3 text-sm text-danger-fg">
              {message}
            </div>
          )}
          {returnPending && (
            <div role="status" className="rounded-lg border border-info/40 bg-info/10 px-4 py-3 text-sm text-info-fg">
              {RETURN_TO_MESSAGE}
            </div>
          )}
        </div>
      )}
      <LoginPage toolName="Clockit" subtitle="Skaleminds Internal" />
    </div>
  );
}
